import React from 'react'
import ProductsBanner from '../components/Products/ProductsBanner'
import AllProducts from '../components/Products/AllProducts'
import SectionFour from '../components/Landing/SectionFour'

const Products = () => {
    return (
        <>
            <ProductsBanner />
            <AllProducts />
            <SectionFour />
        </>
    )
}

export default Products